import { request } from '../../request';

export function cancelSingleShift(shiftId: string, reason: string = '') {
  return request.post<void>(`/v2/shifts/cancel/${shiftId}`, {
    cancellingReason: reason,
  });
}
